export default __webpack_public_path__ + "static/media/brand7.b2af94e5.svg";